import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import { completeAccountLink } from '../../service/socialAuth';
import { methodsForLinkingModal, providerLabel } from '../../service/accountLinking';

export default function AccountLinkingModal({
  open,
  onClose,
  email,
  newProvider,
  onLinked,
}) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(null);

  const methods = methodsForLinkingModal({ newProvider });
  const showPassword = methods.some((m) => m.id === 'password');

  const finish = async (result) => {
    setBusy(null);
    if (!result?.uid) return;
    onLinked?.(result);
    setPassword('');
    onClose?.();
  };

  const handleVia = async (id) => {
    if (id === 'password' && !password) return;
    setBusy(id);
    const result = await completeAccountLink({
      via: id === 'google.com' ? 'google' : id === 'apple.com' ? 'apple' : 'password',
      email,
      password,
    });
    await finish(result);
  };

  return (
    <Dialog open={Boolean(open)} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Use your existing account</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>{email || 'This email'}</strong> already has a Kehilat Bnei Torah
          account. Sign in with the method you used before
          {newProvider ? ` — then we will add ${providerLabel(newProvider)} to it.` : '.'}
        </Typography>
        {methods
          .filter((m) => m.id !== 'password')
          .map((m) => (
            <Button
              key={m.id}
              fullWidth
              variant="outlined"
              disabled={Boolean(busy)}
              onClick={() => handleVia(m.id)}
              sx={{ mb: 1, textTransform: 'none' }}
            >
              {busy === m.id ? <CircularProgress size={18} /> : `Continue with ${m.label}`}
            </Button>
          ))}
        {showPassword && (
          <Box mt={1}>
            <TextField
              fullWidth
              size="small"
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={Boolean(busy)}
              autoComplete="current-password"
            />
            <Button
              fullWidth
              variant="contained"
              disabled={Boolean(busy) || !password}
              onClick={() => handleVia('password')}
              sx={{ mt: 1, textTransform: 'none' }}
            >
              {busy === 'password' ? <CircularProgress size={18} color="inherit" /> : 'Sign in with email'}
            </Button>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={Boolean(busy)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
